import React, { useEffect, useState } from 'react'
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../../../CommonUtils/CommonTable/CommonReactTable';
import { useLocation, useNavigate } from 'react-router-dom';
import * as jnb from 'react-bootstrap';
import Sweetalert, { failureAlert } from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import moment from 'moment';
import { BsEye } from 'react-icons/bs';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { ERROR_MSG } from '../../../CommonUtils/Validations/RegularExpAndVar';
import ImageBucket, { EmpanelImageBucket, ImageBucket_PHOTOS } from '../../../CommonUtils/CommonFileUpload/ImageBucket';
import SecureImage from '../../../CommonUtils/CommonFileUpload/SecureImage';
import { FaDownload } from 'react-icons/fa';
import { ViewImage } from '../../../CommonUtils/CommonFileUpload/ViewImage';

export default function WorkerRegistrationReport2() {

  let navigate = useNavigate();
  let location = useLocation()
  let status = location?.state?.status
  const [showList, setList] = useState([])
  const [showlevel, setlevel] = useState(0);
  const [showdata, setdata] = useState([])
  function GetChequeInReport() {
    let final_status = '';
    let verified = '';
    switch (status) {
      case 'own_total': final_status = 'OWN'; verified = 'T'; break;
      case 'own_approved': final_status = 'OWN'; verified = 'A'; break;
      case 'own_rejected': final_status = 'OWN'; verified = 'R'; break;
      case 'own_pending': final_status = 'OWN'; verified = 'P'; break;
      case 'gsws_total': final_status = 'GSWS'; verified = 'T'; break;
      case 'gsws_approved': final_status = 'GSWS'; verified = 'A'; break;
      case 'gsws_rejected': final_status = 'GSWS'; verified = 'R'; break;
      case 'gsws_pending': final_status = 'GSWS'; verified = 'P'; break;
      case 'alo_total': final_status = 'ALO'; verified = 'T'; break;
      case 'alo_approved': final_status = 'ALO'; verified = 'A'; break;
      case 'alo_rejected': final_status = 'ALO'; verified = 'R'; break;
      case 'alo_pending': final_status = 'ALO'; verified = 'P'; break;
      case 'pending': final_status = 'T'; verified = 'P'; break;
      case 'rejected': final_status = 'T'; verified = 'R'; break;
      case 'approved': final_status = 'T'; verified = 'A'; break;
      case 'total': final_status = 'T'; verified = 'T'; break;
      default:
    }
    let url = config.url.BOC_URL + "worker-reg-status-report-alo?registered_by=" + final_status + '&verified=' + verified;
    CommonAxiosGet(url).then((response) => {
      if (response.data.status === true) {
        setList(response.data.WorkerRegStatusReport);
        setlevel(1);
      }
      else {
        Sweetalert(response.data.sdesc, 'error');
        setList([]);
        setlevel(0)
      }
    })
  }
  const [selectedWorkerId, setSelectedWorkerId] = useState(null);
  const [famDetails, setFamDetails] = useState([]);
  function getdata(userId) {
    let url = config.url.BOC_URL + "worker-reg?userId=" + userId;
    CommonAxiosGet(url).then((response) => {
      if (response.data.status === true) {
        const mainData = response.data.WorkerRegistration[0];
        setdata(mainData);
        setSelectedWorkerId(mainData.worker_id)

        // parse fam_details
        try {
          const parsedFam = JSON.parse(mainData.fam_details);
          setFamDetails(parsedFam);
        } catch (e) {
          console.error("Failed to parse fam_details", e);
          setFamDetails([]);
        }

        setShowPreviewModal(true);
      } else {
        setdata({});
        setFamDetails([]);
      }
    });
  }

  useEffect(() => { GetChequeInReport() }, [])
  const userValidationSchema = Yup.object().shape({
    workerStatus: Yup.string().required(ERROR_MSG).nullable(),
    remarks: Yup.string().required(ERROR_MSG).nullable(),

  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      workerStatus: '',
      remarks: '',
    },
    onSubmit: (values) => {
      console.log("Form submitted", values);
      submitvalues(values);
    },
    validationSchema: userValidationSchema,
  });

  const submitvalues = (values) => {
    const payload = {
      workerId: selectedWorkerId,
      verified: values.workerStatus,
      remarks: values.remarks
    };
    // console.log('saiii: ', payload)
    Swal.fire({
      title: 'Are you sure want to submit?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        const url = config.url.BOC_URL + 'worker-status';
        CommonAxiosPost(url, payload).then((response) => {
          if (response?.data?.scode === "01") {
            Sweetalert(response?.data?.sdesc, 'success').then(() => {
              navigate('/WorkerRegistrationReport');
            });
          } else if (response?.data?.scode === "02") {
            Sweetalert(response?.data?.sdesc, "", 'info');
          } else {
            failureAlert(response?.data?.sdesc, 'error');
          }
        });
      }
    });
  }
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  // const [selectedImage, setSelectedImage] = useState(null);
  // const handleView = (image) => {
  //   setSelectedImage(image);
  // };
  const columns = [
    {
      Header: 'S.NO',
      accessor: (row, index) => index + 1,
      Footer: '',

    },
    {
      Header: 'Worker ID',
      accessor: (row) => row.worker_id,
      Footer: '',

    },
    {
      Header: 'First Name',
      accessor: (row) => row.first_name,
      Footer: '',

    },

    {
      Header: 'Phone No',
      accessor: (row) => row.phone_no,
      Footer: '',

    },
    // {
    //   Header: 'Aadhaar No',
    //   accessor: (row) => row.mask_aadhaar,
    //   Footer: '',

    // },
    {
      Header: 'Present Office Name',
      accessor: (row) => row.present_office_name,
      Footer: '',
    },
    {
      Header: 'Type Of Work',
      accessor: (row) => row.type_of_work,
      Footer: '',

    },
    {
      Header: 'View IDCard',
      accessor: 'approvedd',
      Cell: ({ row }) => {
        const status = row.original.status?.toLowerCase();
        const userId = row.original.user_id;

        let statusClass = '';
        let statusText = '';

        switch (status) {
          case 'approved':
            statusClass = 'btn btn-success btn-sm'; // green
            statusText = 'View';
            break;
          case 'rejected':
            statusText = 'Rejected';
            break;
          case 'pending':
            statusText = 'Pending';
            break;
          default:
            statusText = 'Unknown';
            break;
        }

        return (
          <div className="d-flex justify-content-center">
            {status === 'approved' ? (
              <button
                className={statusClass}
                onClick={() => navigate("/IdCard", { state: { userId } })}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  fontSize: "13px",
                  padding: "6px 10px",
                }}
              >
                {statusText}
              </button>
            ) : (
              <span
                style={{
                  fontSize: "13px",
                  color:
                    status === 'rejected'
                      ? 'red'
                      : status === 'pending'
                        ? 'blue'
                        : 'gray',
                }}
              >
                {statusText}
              </span>
            )}
          </div>
        );
      },
      Footer: '',
    }

    ,
    {
      Header: 'Action',
      accessor: 'approved',
      Cell: ({ row }) => {
        const status = row.original.status?.toLowerCase();
        let statusClass = '';
        let statusText = '';
        switch (status) {
          case 'approved':
            statusClass = 'btn btn-success btn-sm'; // green
            statusText = 'Approved';
            break;
          case 'rejected':
            statusClass = 'btn btn-danger btn-sm'; // red
            statusText = 'Rejected';
            break;
          case 'pending':
            statusClass = 'btn btn-primary btn-sm'; // blue
            statusText = 'Pending';
            break;
          default:
            statusClass = 'btn btn-secondary btn-sm'; // gray fallback
            statusText = 'Unknown';
            break;
        }

        return (
          <div className="d-flex justify-content-center">
            <button
              type="button"
              className={statusClass}
              onClick={() => getdata(row.original.user_id)}
            >
              {statusText}
            </button>
          </div>
        );
      },
      Footer: '',
    },
    {
      Header: 'Remarks',
      accessor: (row) => {
        // Check if status is Approved
        const status = row.status?.toLowerCase();
        if (status === 'approved') {
          return 'Signed';
        } else {
          return row.remarks || '';
        }
      },
      Footer: '',
    },
  ]
  function formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB').replace(/\//g, '-');
  }

  return (
    <React.Fragment>
      <Header />
      <div className="main_section"> </div>
      <CommonPageHeading heading="Worker Registration Status Wise Report" />
      <jnb.Container className="outer-page-content-container">
        <FormikProvider value={formik}>
          <jnb.Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="form_adjust" id="form-start">
            {showList.length > 0 && showlevel === 1 && (
              <div className="table-responsive">
                <CommonReactTable columns={columns} data={showList || []} showFooter="false" filename="DepartmentReport" paginationCount="All" pagination="true" />
              </div>)}


            <jnb.Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} size="xl" centered scrollable className='mt-5' backdrop="static">
              <jnb.Modal.Header closeButton>
                <jnb.Modal.Title className="w-100 text-center">Preview Details</jnb.Modal.Title>

              </jnb.Modal.Header>

              <jnb.Modal.Body>
                <h5 style={{ textAlign: 'center', whiteSpace: 'pre-line', color: '#074079' }} >
                  <strong>
                    ఆంధ్ర ప్రదేశ్ భవన మరియు ఇతర నిర్మాణ రంగ కార్మికుల నిబంధనలు. 1999 రూల్ 33ఏ (2){"\n"}
                    భవన మరియు ఇతర నిర్మాణ కార్మికునిగా రిజిస్టర్ చేసుకొనుటకు దరఖాస్తు.
                  </strong>
                </h5>

                <div className="inner-herbpage-service-title-sub">
                  <h1>Basic Details(ప్రాథమిక వివరాలు)</h1>
                </div>

                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                        <tr>
                          <td>Worker ID(కార్మిక గుర్తింపు సంఖ్య): </td>
                          <th>{showdata?.worker_id}</th>
                          <td>Aadhaar No(ఆధార్ సంఖ్య): </td>
                          <th>{showdata?.mask_aadhaar}</th>

                        </tr>
                        <tr>
                          <td>First Name(మొదటి పేరు):</td>
                          <th>{showdata?.first_name}</th>
                          <td>Last(Sur) Name(చివరి పేరు / ఇంటి పేరు):</td>
                          <th>{showdata?.last_name}</th>

                        </tr>
                        <tr>
                          <td>Gender(లింగం)</td>
                          <th>{showdata?.gender === 'M' ? 'Male' : showdata?.gender === 'F' ? 'Female' : 'Transgender'}</th>
                          <td>Marital Status(వివాహ స్థితి)</td>
                          <th>{showdata?.marital_status}</th>
                        </tr>
                        <tr>
                          <td>Religion(మతం)</td>
                          <th>{showdata?.religiondesc}</th>
                          <td>Caste(కులం)</td>
                          <th>{showdata?.caste_desc}</th>
                        </tr>
                        <tr>
                          <td>Sub Caste(ఉప కులం)</td>
                          <th>{showdata?.sub_caste_desc}</th>
                          <td>Phone No(ఫోన్ నంబర్)</td>
                          <th>{showdata?.phone_no}</th>

                        </tr>
                        <tr>
                          <td>DOB(పుట్టిన తేది)</td>
                          <th>{moment(showdata?.dob).format("DD-MM-YYYY")}</th>
                          <td>Father /Husband Name(తండ్రి / భర్త పేరు)</td>
                          <th>{showdata?.father_name}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


                <div className="inner-herbpage-service-title-sub">
                  <h1>Family Details(కుటుంబ వివరాలు)</h1>
                </div>
                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Member Name (సభ్యుని పేరు)</th>
                          <th>Relation (బంధుత్వం)  </th>
                          <th>Member DOB (సభ్యుని పుట్టిన తేదీ)</th>
                          <th>Aadhaar No. (ఆధార్ సంఖ్య)</th>
                          <th>Is He/She Nominee (అతను/ ఆమె నామినీనా)? </th>
                          <th>% of Benefits? (ప్రయోజన శాతం?)</th>
                        </tr>
                      </thead>
                      <tbody>

                        {famDetails.map((member, idx) => (
                          <tr key={idx}>
                            <td>{member.member_name}</td>
                            <td>
                              {{
                                '1': 'Mother(తల్లి)',
                                '2': 'Father(తండ్రి)',
                                '3': 'Brother(అన్న / తమ్ముడు)',
                                '4': 'Sister(అక్క / చెల్లి)',
                                '5': 'Grand Father(తాతయ్య)',
                                '6': 'Grand Mother(అమ్మమ్మ / నానమ్మ)',
                                '7': 'Spouse(జీవిత భాగస్వామి)',
                                '8': 'Daughter(కుమార్తె)',
                                '9': 'Son(కుమారుడు)',
                              }[member.relation] || ''}
                            </td>
                            <td>{formatDate(member.member_dob)}</td>
                            <td>{member.member_uid}</td>
                            <td>{member.is_nominee === 'Y' ? 'Yes (అవును)' : 'NO(కాదు)'}</td>
                            <td>{member.nominee_percentage}</td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1>Bank Details(బ్యాంక్ వివరాలు)</h1>
                </div>
                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <tbody style={{ textAlign: "left", fontSize: "15px" }}>

                        <tr>
                          <td>IFSC Code(ఐఎఫ్‌ఎస్‌సి కోడ్)</td>
                          <th>{showdata.ifsc_code}</th>
                          <td>Bank Name(బ్యాంకు పేరు)</td>
                          <th>{showdata.bank_name}</th>

                        </tr>
                        <tr>
                          <td>Branch Name(శాఖ పేరు)</td>
                          <th>{showdata.branch_name}</th>
                          <td>Bank Account No(బ్యాంక్ ఖాతా సంఖ్య)</td>
                          <th>{showdata.bank_account_no}</th>
                        </tr>
                        <tr>
                          <td>Name in Bank(బ్యాంకులో పేరు)</td>
                          <th>{showdata.name_in_bank}</th>
                          <td>Bank Passbook(1st page)(బ్యాంక్ పాస్‌బుక్ (మొదటి పేజీ))</td>

                          {showdata?.upload_bank_photo && (
                            <button
                              onClick={() => ViewImage(showdata?.upload_bank_photo)}
                              style={{ padding: 0, border: "none", background: "none", cursor: "pointer" }}
                            >
                              <img
                                src={config.url.FILE_DOWNLOAD_URL + showdata?.upload_bank_photo}
                                alt="Uploaded"
                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                              />
                            </button>

                            // <SecureImage filePath={showdata.upload_bank_photo} />

                          )}
                          <FaDownload
                            size={40}
                            style={{ cursor: 'pointer', color: '#007bff' }}
                            onClick={() => {
                              const fileUrl = config.url.FILE_DOWNLOAD_URL + showdata.upload_bank_photo;
                              const link = document.createElement('a');
                              link.href = fileUrl;
                              link.download = showdata.upload_bank_photo.split('/').pop(); // get file name
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1>Address for Communication(చిరునామా) </h1>
                  <h1 style={{ fontSize: "18px" }}>Present Address(ప్రస్తుత చిరునామా)</h1>

                </div>
                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                        <tr>
                          <td>District(జిల్లా)</td>
                          <th>{showdata?.present_district}</th>
                          <td>Mandal(మండలం)</td>
                          <th>{showdata.present_mandal}</th>
                        </tr>
                        <tr>
                          <td>Village(గ్రామం)</td>

                          <th>{showdata.present_village}</th>
                          <td>Pincode(పిన్‌కోడ్)</td>
                          <th>{showdata.present_pincode}</th>

                        </tr>
                        <tr>
                          <td>Door No(ఇంటి నంబర్)</td>
                          <th>{showdata.present_door_no}</th>
                          <td>Address(చిరునామా)</td>
                          <th>{showdata.present_address}</th>
                        </tr>
                        <tr>
                          <td>Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</td>
                          <th>{showdata.present_division}</th>
                          <td>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</td>
                          <th>{showdata.present_land_mark}</th>
                        </tr>
                        <tr>
                          <td>town/city(నగరం/పట్టణం)</td>
                          <th>{showdata.present_city}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {showdata.is_permanent === "N" && (
                  <>
                    <div className="inner-herbpage-service-title-sub">
                      <h1 style={{ fontSize: "18px" }}> Permanent Address(శాశ్వత చిరునామా)</h1>
                    </div>
                    <div className="personal-row personal-roweducation">
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                            <tr>
                              <td>District(జిల్లా)</td>
                              <th>{showdata.permanent_district}</th>
                              <td>Mandal(మండలం)</td>
                              <th>{showdata.permanent_mandal}</th>
                            </tr>
                            <tr>
                              <td>Village(గ్రామం)</td>
                              <th>{showdata.permanent_village}</th>
                              <td>Pincode(పిన్‌కోడ్)</td>
                              <th>{showdata.permanent_pincode}</th>

                            </tr>
                            <tr>
                              <td>Door No(ఇంటి నంబర్)</td>
                              <th>{showdata.permanent_door_no}</th>
                              <td>Address(చిరునామా)</td>
                              <th>{showdata.permanent_address}</th>
                            </tr>
                            <tr>
                              <td>Division/Ward Number(డివిజన్/వార్డ్ నంబర్)</td>
                              <th>{showdata.permanent_division}</th>
                              <td>Landmark/Locality(ల్యాండ్‌మార్క్/ప్రాంతం)</td>
                              <th>{showdata.permanent_land_mark}</th>
                            </tr>
                            <tr>
                              <td>town/city(నగరం/పట్టణం)</td>
                              <th>{showdata.permanent_city}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </>
                )}
                <div className="inner-herbpage-service-title-sub">
                  <h1>Other Details(ఇతర వివరాలు)</h1>
                </div>
                <div className="personal-row personal-roweducation">
                  <p><strong>Is he/she is an MGNREGS worker(అతను/ఆమె మహాత్మా గాంధీ జాతీయ గ్రామీణ ఉపాధి కార్మికులా)? : </strong> {showdata.is_nregs === "Y" ? "Yes" : "No"}</p>
                  {showdata.is_nregs === "Y" && (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                          <tr>
                            <td>Job card Number(జాబ్ కార్డ్ నంబర్)</td>
                            <th>{showdata.job_card_no}</th>
                            <td>No.of work days copy(పని రోజుల ప్రతులు)</td>
                            <th> {showdata.word_days_copy && (


                              <SecureImage filePath={showdata.word_days_copy} />

                            )}
                              <FaDownload
                                size={40}
                                style={{ cursor: 'pointer', color: '#007bff' }}
                                onClick={() => {
                                  const fileUrl = config.url.FILE_DOWNLOAD_URL + showdata.word_days_copy;
                                  const link = document.createElement('a');
                                  link.href = fileUrl;
                                  link.download = showdata.word_days_copy.split('/').pop(); // get file name
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                }}
                              />
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1>Trade Union(కార్మిక సంఘం)</h1>
                </div>
                <div className="personal-row personal-roweducation">
                  <p><strong>Is the worker a member of any trade union (కార్మికుడు/కార్మికురాలు ఏదైనా కార్మిక సంఘంలో సభ్యుడా/సభ్యురాలా)?  : </strong> {showdata.is_union_member === "Y" ? "Yes" : "No"}</p>
                  {showdata.is_union_member === "Y" && (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                          <tr>
                            <td>Union Name(యూనియన్ పేరు)</td>
                            <th>{showdata.union_name}</th>
                            <td>Registration No(నమోదు సంఖ్య)</td>
                            <th> {showdata.reg_no}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1>Work Place Details(పని ప్రదేశం వివరాలు)</h1>
                </div>
                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                        <tr>
                          <td>Name of the Employer(యాజమాని పేరు) </td>
                          <th>{showdata.emp_name}</th>
                          <td>Name of the Construction Organisation(నిర్మాణ సంస్థ పేరు)</td>
                          <th>{showdata.present_office_name}</th>
                        </tr>
                        <tr>
                          <td>Trade of work(పని వ్యాపారం)</td>
                          <th>{showdata.type_of_work}</th>
                          <td>Do you need any training(మీకు శిక్షణ అవసరమా)?</td>
                          <th>{showdata.work_capability === "Y" ? "Yes(అవును)" : "No(కాదు)"}</th>
                          {/* <td>Category of Worker(కార్మికుల వర్గీకరణ)</td>
                          <th>{showdata.work_capability === '1' ? 'High Skilled(అత్యున్నత నైపుణ్యం)' : showdata.work_capability === '2' ? 'Skilled(నైపుణ్యం ఉన్నవారు)' : showdata.work_capability === '3' ? 'Semi Skilled(పాషిక నైపుణ్యం లేని వారు)' : 'Un-Skilled(నైపుణ్యం లేని వారు)'}</th> */}
                        </tr>
                        <tr>
                          <td>District(జిల్లా)</td>
                          <th>{showdata.office_district}</th>
                          <td>Mandal(మండలం)</td>
                          <th>{showdata.office_mandal}</th>
                        </tr>
                        <tr>

                          <td>Village(గ్రామం)</td>
                          <th>{showdata.office_village}</th>
                          <td>Pincode(పిన్ కోడ్)</td>
                          <th>{showdata.office_pincode}</th>
                        </tr>
                        <tr>
                          <td>Door No(ఇంటి నంబర్)</td>
                          <th>{showdata.office_door_no}</th>
                          <td>Address(చిరునామా)</td>
                          <th>{showdata.office_address}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1>Uploads(అప్‌లోడ్లు)</h1>
                </div>
                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                        <tr>
                          <td>Passport Size Photo(పాస్‌పోర్ట్ సైజ్ ఫోటో)</td>
                          {showdata.upload_photo && (

                            <SecureImage filePath={showdata.upload_photo} />

                          )}
                          <FaDownload
                            size={40}
                            style={{ cursor: 'pointer', color: '#007bff' }}
                            onClick={() => {
                              const fileUrl = config.url.FILE_DOWNLOAD_URL + showdata.upload_photo;
                              const link = document.createElement('a');
                              link.href = fileUrl;
                              link.download = showdata.upload_photo.split('/').pop(); // get file name
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          />
                          <td>Aadhaar Photo(ఆధార్ కార్డ్)</td>
                          {showdata.upload_aadhaar_photo && (

                            <SecureImage filePath={showdata.upload_aadhaar_photo} />
                          )}
                          <FaDownload
                            size={40}
                            style={{ cursor: 'pointer', color: '#007bff' }}
                            onClick={() => {
                              const fileUrl = config.url.FILE_DOWNLOAD_URL + showdata.upload_aadhaar_photo;
                              const link = document.createElement('a');
                              link.href = fileUrl;
                              link.download = showdata.upload_aadhaar_photo.split('/').pop(); // get file name
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          />
                        </tr>
                        <tr>
                          <td>Self Affidavit (స్వీయ ధృవీకరణ)</td>

                          {showdata.upload_self_affidavit && (
                            <>
                              {showdata.upload_self_affidavit.toLowerCase().endsWith('.pdf') ? (
                                // ✅ Case 1: PDF file → Show only download icon
                                <FaDownload
                                  size={40}
                                  style={{ cursor: 'pointer', color: '#007bff' }}
                                  onClick={() => {
                                    const fileUrl = config.url.FILE_DOWNLOAD_URL + showdata.upload_self_affidavit;
                                    const link = document.createElement('a');
                                    link.href = fileUrl;
                                    link.download = showdata.upload_self_affidavit.split('/').pop();
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                  }}
                                />
                              ) : (
                                // ✅ Case 2: Image file → Show image + download icon
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                  <SecureImage filePath={showdata.upload_self_affidavit} />

                                  <FaDownload
                                    size={25}
                                    style={{ cursor: 'pointer', color: '#007bff' }}
                                    onClick={() => {
                                      const fileUrl = config.url.FILE_DOWNLOAD_URL + showdata.upload_self_affidavit;
                                      const link = document.createElement('a');
                                      link.href = fileUrl;
                                      link.download = showdata.upload_self_affidavit.split('/').pop();
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1>Payment (చెల్లింపు వివరాలు)   </h1>                                  </div>
                <div className="personal-row personal-roweducation">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                        <tr>
                          <td>Years(సంవత్సరాలు):</td>
                          {/* <th>{showData.payment_status}</th> */}
                          <th>{showdata.work_year}</th>
                          <td>₹Amount(మొత్తం)</td>
                          {/* <th>{showData.transaction_amount}</th> */}
                          <th>₹{showdata.amount}</th>
                          <td>Payment Status(చెల్లింపు స్థితి)</td>
                          {/* <th>{showData.payment_status}</th> */}
                          <th style={{ color: showdata.amount_status === 'S' ? 'green' : 'red' }}>
                            {showdata.amount_status === 'S' ? 'SUCCESS' : 'FAILURE'}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {showdata.is_alo_verified === null ? (
                  <React.Fragment>
                    <jnb.Row>
                      {/* <jnb.Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
           <jnb.InputGroup className="">
          <jnb.Form.Label>Worker Status</jnb.Form.Label>
          <Field as="select"
          className="form-control w-100 "
            name="workerStatus"
          >
            <option value="">-- Select Status --</option>
            <option value="true">Approved</option>
            <option value="false">Rejected</option>
          </Field>
 <ErrorMessage name="workerStatus" component="div" className="text-error" />
          </jnb.InputGroup>
        </jnb.Col>
        {formik.values.workerStatus && (
          <jnb.Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
             <jnb.InputGroup className="">
            <jnb.Form.Label>Remarks</jnb.Form.Label>
            <Field
             className="form-control w-100 "
              type="text"
              name="remarks"
              placeholder="Enter remarks"
            />
 <ErrorMessage name="remarks" component="div" className="text-error" />
</jnb.InputGroup>
          </jnb.Col> */}
                      <jnb.Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
                        <jnb.InputGroup>
                          <jnb.Form.Label>Worker Status</jnb.Form.Label>
                          <Field
                            as="select"
                            className="form-control w-100"
                            name="workerStatus"
                          >
                            <option value="">-- Select Status --</option>
                            <option value="true">Approved</option>
                            <option value="false">Rejected</option>
                          </Field>
                          <ErrorMessage name="workerStatus" component="div" className="text-error" />
                        </jnb.InputGroup>
                      </jnb.Col>

                      {formik.values.workerStatus && (<>
                        <jnb.Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3} >
                          <jnb.InputGroup >
                            <jnb.Form.Label>{formik.values.workerStatus === "true" ? "Upload Signed Photo" : "Remarks"} </jnb.Form.Label>
                            {formik.values.workerStatus === "true" ? (
                              <div className="d-flex align-items-start gap-2 w-100">
                                <input
                                  type="file"
                                  name="remarks"
                                  className="form-control w-100"
                                  onChange={(e) => {
                                    const file = e.currentTarget.files[0];
                                    if (file) {
                                      let fileVal = formik.values.remarks;
                                      let filename = fileVal + "_remarks";
                                      EmpanelImageBucket(e, formik, "remarks", filename);
                                    }
                                  }}
                                />
                                {formik.values.remarks !== "" && (
                                  <jnb.Button
                                    type="button"
                                    //className="btn btn-outline-primary"
                                    className="btn btn-primary ms-2 p-2 "
                                    style={{ height: "38px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                    onClick={() => {
                                      // handleView(formik.values.remarks)
                                      ViewImage(formik.values.remarks);
                                    }}
                                  >
                                    <BsEye></BsEye>
                                  </jnb.Button>
                                )}
                              </div>
                            ) : (
                              <Field
                                type="text"
                                className="form-control w-100"
                                name="remarks"
                                placeholder="Enter remarks"
                              />
                            )}
                            <ErrorMessage name="remarks" component="div" className="text-error" />
                          </jnb.InputGroup>
                        </jnb.Col>
                      </>
                      )}

                      <jnb.Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3} className="pt-4 mt-2">
                        {showdata.is_alo_verified === null && (
                          <button
                            type="submit"
                            className="btn btn-success"
                            onClick={() => {
                              formik.handleSubmit();
                            }}
                          >
                            Submit
                          </button>
                        )}
                      </jnb.Col>
                    </jnb.Row>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {showdata.is_alo_verified === false && (
                      <jnb.Row className="pb-0 pt-2 mx-0 d-flex justify-content-center align-items-center" style={{ minHeight: '10vh' }}>
                        <jnb.Col md={12} className="text-center mt-4">
                          <div className="alert alert-danger text-center" role="alert">
                            <div>
                              <b style={{ color: 'red', fontWeight: 'bold', fontSize: '1.1rem' }}> ❌ Rejected</b>
                            </div>
                          </div>
                        </jnb.Col>
                      </jnb.Row>
                    )}

                    {showdata.is_alo_verified === true && (
                      <jnb.Row className="pb-0 pt-2 mx-0 d-flex justify-content-center align-items-center" style={{ minHeight: '10vh' }}>
                        <jnb.Col md={12} className="text-center mt-4">
                          <div className="alert alert-success text-center" role="alert">
                            <b style={{ color: 'green', fontWeight: 'bold', fontSize: '1.1rem' }}> ✅ Approved Successfully</b>
                          </div>
                        </jnb.Col>
                      </jnb.Row>
                    )}
                  </React.Fragment>
                )}




              </jnb.Modal.Body>

              <jnb.Modal.Footer>
                {/* <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowPreviewModal(false);
                    document.getElementById("form-start").scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Edit
                </button>
            
                <button
                type="submit"
                  className="btn btn-success"
                  onClick={() => {
                    submitvalues(formik.values);
                  }}
                >
                  Submit
                </button> */}


              </jnb.Modal.Footer>
            </jnb.Modal>
          </jnb.Form>
        </FormikProvider>
      </jnb.Container>
      {/* {selectedImage && (
        <ViewImage
          fileName={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )} */}

    </React.Fragment>

  )
}
